import Vue from 'vue'
import App from './App'
import mixins from './helpers/mixins'
import { router } from './helpers/router'
import { store } from './store/index'
import './assets/css/main.scss'

import { Icon } from 'leaflet'
import 'leaflet/dist/leaflet.css'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

import VueRx from 'vue-rx'
import VueScrollTo from 'vue-scrollto'

import 'vue-resize/dist/vue-resize.css'
import VueResize from 'vue-resize'

import i18n from './i18n/i18n'
import es from 'vuetify/es5/locale/es'
import en from 'vuetify/es5/locale/en'
import ca from 'vuetify/es5/locale/ca'

import VeeValidate from 'vee-validate'
import esValidationMessages from 'vee-validate/dist/locale/es'
import enValidationMessages from 'vee-validate/dist/locale/en'
import caValidationMessages from 'vee-validate/dist/locale/ca'

import IgTextField from './components/widgets/Input/IgTextField'
import IgTextFieldNumber from './components/widgets/Input/IgTextFieldNumber'

import rules from '@/helpers/vuetifyRules'
import mixinConverterLanguage from '@/helpers/languageConvert'

delete Icon.Default.prototype._getIconUrl

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Vue.component('IgTextField', IgTextField)
Vue.component('IgTextFieldNumber', IgTextFieldNumber)

Vue.use(VueRx)
Vue.use(i18n)
Vue.use(VeeValidate, {
  iconfont: 'md',
  i18n,
  dictionary: {
    es: esValidationMessages,
    en: enValidationMessages,
    ca: caValidationMessages
  }
})

Vue.use(VueScrollTo, {
  offset: -50
})

Vue.use(VueResize)

/**
 * Framework Vuetify Material Design
 */
Vue.use(Vuetify, {
  theme: {
    primary: '#62C6C5',
    secondary: '#6273B7',
    accent: '#454545',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  },
  options: {
    customProperties: true
  },
  lang: {
    locales: { es, en, ca },
    current: localStorage.getItem('locale') || 'es'
  }
})
Vue.mixin(mixins)
Vue.mixin(mixinConverterLanguage)
Vue.mixin({
  data() {
    return {
      defaultValues: {
        languageRequire: process.env.VUE_APP_LANGUAGE_REQUIRE
      }
    }
  }
})
Vue.mixin(rules)
store.dispatch('languages/setInit')

Vue.config.errorHandler = err => {
  console.log('Exception: ', err)
}
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  render: h => h(App)
})
